__turbopack_context__.v({
  "name": "Tabs-module__ypby_W__name",
  "tab": "Tabs-module__ypby_W__tab",
  "tabFirst": "Tabs-module__ypby_W__tabFirst",
  "tabLast": "Tabs-module__ypby_W__tabLast",
  "tabMiddle": "Tabs-module__ypby_W__tabMiddle",
  "tabNextSelected": "Tabs-module__ypby_W__tabNextSelected",
  "tabNoBorderRight": "Tabs-module__ypby_W__tabNoBorderRight",
  "tabPrevSelected": "Tabs-module__ypby_W__tabPrevSelected",
  "tabSelected": "Tabs-module__ypby_W__tabSelected",
  "tabWithBorderRight": "Tabs-module__ypby_W__tabWithBorderRight",
  "tabsList": "Tabs-module__ypby_W__tabsList",
  "tabsRoot": "Tabs-module__ypby_W__tabsRoot",
});
